<template>
  <div @click.stop="onTriggerClick">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DropdownTrigger',
  inject: ['dropdownV2'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onTriggerClick() {
      if (this.disabled) return
      this.dropdownV2.toggleDropdown()
    },
  },
}
</script>
